@if (order$ | async; as order) {
  <div class="row">
    <div class="cx-summary col-12">
      <app-efa-order-summary [cart]="order"></app-efa-order-summary>
    </div>
  </div>
}
